import { checkIfTokenExpired, getCookies } from '../utils/authUtils'
import { isClient } from '../utils/isClient'
import _axios from 'axios'

export const getAxios = () => {
   const axios = _axios.create()

   axios.interceptors.request.use(async config => {
      if (isClient) {
         var nextAuthToken = getCookies()['next-auth-token']
         var [digitalMenuScreenCodeTemp, digitalMenuScreenCode] = [
            localStorage.getItem('digital-menu-screen-code-temp'),
            localStorage.getItem('digital-menu-screen-code'),
         ]

         // Remove Tokens and reload the page if token is expired
         if (
            checkIfTokenExpired(
               sessionStorage.getItem('kioskGuestSessionToken') ||
                  sessionStorage.getItem('guestSessionToken')
            )
         ) {
            sessionStorage.removeItem('kioskGuestSessionToken')
            sessionStorage.removeItem('guestSessionToken')
            window.location.reload()
         }
      }
      const sessionId = isClient && sessionStorage.getItem('sessionId')

      return {
         ...config,
         headers: {
            ...config.headers,
            'app-version': process.env.NEXT_PUBLIC_API_SERVER_VERSION,
            ...(isClient && {
               ...(nextAuthToken && {
                  'next-auth-token': nextAuthToken,
               }),
               ...(sessionStorage &&
                  (sessionStorage.getItem('kioskGuestSessionToken') ||
                     sessionStorage.getItem('guestSessionToken')) && {
                     'Guest-Session-Token':
                        sessionStorage.getItem('kioskGuestSessionToken') ||
                        sessionStorage.getItem('guestSessionToken'),
                  }),
               ...((digitalMenuScreenCodeTemp || digitalMenuScreenCode) && {
                  'digital-menu-screen-code':
                     digitalMenuScreenCodeTemp || digitalMenuScreenCode,
               }),
               ...(sessionId && { 'session-id': sessionId }),
            }),
         },
      }
   })

   return axios
}

export const _fetch = (url, props = {}) => {
   return fetch(url, {
      ...props,
      headers: {
         ...(props.headers || {}),
         'app-version': process.env.NEXT_PUBLIC_API_SERVER_VERSION,
      },
   })
}
